import { IChatProvider } from '@enuan/chat__utils';
import React from 'react';

type IInstanceContext = {
	instance: IChatProvider;
	restart: () => Promise<void>;
	refreshCredentials: () => Promise<void>;
	startConnection: IChatProvider['initConnection'];
};
export const instanceContext = React.createContext<IInstanceContext>(
	{} as IInstanceContext,
);
